import GridColumn from "@/classes/component-classes/GridColumn";
import StockSearchItem from "@/classes/stock/StockSearchItem";
import {StockSearchPillCollectionBase} from "@/classes/stock/StockSearchPillCollectionBase";

export default class StockSearch {
    constructor() {

        this.searchCriteria = new StockSearchItem();

        this.searchPills = new StockSearchPillCollectionBase();

        this.searchData = [];
        this.lineData = [];
        this.searchGridCurrentPage = 1;
        this.searchGridPageRange = 1;
        this.lineGridCurrentPage = 1;
        this.lineGridPageRange = 1;
        this.isSearchData = false;
        this.searchGroup = true;
        this.skuGroupSelected = false;
        this.hideExcelDownloadBusy = true;
        this.openDetailsDrawer = false;

        this.metaData = {

            warehouses: []
        }

        this.gridColumns = [

            new GridColumn('1', 'SKU Group', 'skuGroup', '220', true, false),
            new GridColumn('2', 'SKU Name', 'skuName', '280', true, false),
            new GridColumn('3', 'SKU Number', 'skuNumber', '180', true, false),
            new GridColumn('4', 'Description', 'description', '300', true, false),
            new GridColumn('5', 'QTY', 'quantity', '40', true, false),
            new GridColumn('6', 'Allocated', 'allocated', '68', true, false),
            new GridColumn('7', 'Packed', 'packed', '60', true, false),
            new GridColumn('8', 'Available', 'available', '65', true, false),
            new GridColumn('11', 'Comments', 'comments', '300', true, false ),
            new GridColumn('9', 'Currency', 'currency', '50', true, false),
            new GridColumn('10', 'Value', 'value', '60', true, false),

        ]

        this.tempLineCols = [

            new GridColumn('1', '', 'warehouse', '1770', true, false, 50),
            // new GridColumn('2', 'Location', 'location', '140', true, true, 10),
            // new GridColumn('3', 'Allocated', 'allocated', '60', true, true, 10),
            // new GridColumn('4', 'Description Header', 'desc1', '140', true, true, 10),
            // new GridColumn('5', 'Description Header', 'desc2', '140', true, true, 10),
            // new GridColumn('6', 'Description Header', 'desc3', '140', true, true, 10),
            // new GridColumn('7', 'Description Header', 'desc4', '140', true, true, 10),
            // new GridColumn('8', 'Description Header', 'desc5', '140', true, true, 10),
            // new GridColumn('9', 'Description Header', 'desc6', '140', true, true, 10),
            // new GridColumn('10', 'Currency', 'currency', '50', true, true, 10),
            // new GridColumn('11', 'Value', 'value', '50', true, true, 10),
            // new GridColumn('12', 'Comments', 'skuComments', '230', true, false, 40),
            // new GridColumn('13', 'Quantity', 'quantity', '60', true, true, 10),

        ]


    }
}
